module.exports = {
      id: "authorwhite-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#authorwhite",
      toString: function () {
        return this.url;
      }
    }